import { render, staticRenderFns } from "./CustomDomainPage.vue?vue&type=template&id=22285f95&scoped=true"
import script from "./CustomDomainPage.vue?vue&type=script&lang=js"
export * from "./CustomDomainPage.vue?vue&type=script&lang=js"
import style0 from "./CustomDomainPage.vue?vue&type=style&index=0&id=22285f95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22285f95",
  null
  
)

export default component.exports